/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box } from '@material-ui/core';
import styles from './styles';

const ActionButtonContainer: React.FC = props => {
  const { children } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      css={styles.actionsContainer}
    >
      {children}
    </Box>
  );
};

export default ActionButtonContainer;
